import { ModalHeader } from 'reactstrap';
import classNames from 'classnames';
import { NSButton } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import ActivityActionsMenu from '../../ActivityActionsMenu/ActivityActionsMenu';

type TimelineSlideoutHeaderProps = {
    name: string;
    editMode: boolean;
    isDetailsTab: boolean;
    isSaving: boolean;
    toggle: () => void;
    onEdit: () => void;
    onSave: () => void;
    onCancel: () => void;
    onDuplicate: () => void;
    onDelete: () => void;
};

const TimelineSlideoutHeader = ({
    name,
    editMode,
    isDetailsTab,
    isSaving,
    toggle,
    onEdit,
    onSave,
    onCancel,
    onDuplicate,
    onDelete,
}: TimelineSlideoutHeaderProps) => (
    <ModalHeader
        tag="div"
        toggle={toggle}
        className="d-flex flex-row-reverse p-0 align-items-center"
        cssModule={{ 'modal-title': classNames('modal-title w-100'), close: 'btn btn-lg' }}
    >
        <div className="d-flex justify-content-between align-items-center w-100 px-3 py-2">
            <h5 className="text-dark mb-0 text-truncate">{name}</h5>
            <div className="d-flex align-items-center">
                <RenderIf isTrue={!editMode}>
                    <ActivityActionsMenu
                        onDuplicate={onDuplicate}
                        onDelete={onDelete}
                        dataTestIdPrefix="timeline-slideout"
                    />
                    <RenderIf isTrue={isDetailsTab}>
                        <NSButton
                            dataTestId="timeline-slideout-edit-btn"
                            callback={onEdit}
                            className="ml-1"
                            color="primary"
                        >
                            Edit
                        </NSButton>
                    </RenderIf>
                </RenderIf>
                <RenderIf isTrue={editMode && isDetailsTab}>
                    <NSButton
                        dataTestId="timeline-slideout-cancel-btn"
                        callback={onCancel}
                        className="ml-1"
                        color="secondary"
                        disabled={isSaving}
                    >
                        Cancel
                    </NSButton>
                    <NSButton
                        dataTestId="timeline-slideout-save-btn"
                        callback={onSave}
                        className="ml-1"
                        color="primary"
                        isLoading={isSaving}
                    >
                        Save
                    </NSButton>
                </RenderIf>
            </div>
        </div>
    </ModalHeader>
);

export default TimelineSlideoutHeader;
